import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';

class I3SOption extends React.Component{
    constructor(){
        super();
        this.state={
            isSettingOpen:false,
            cover : "null",
            helpMode : "None"
        };
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        if(this.props.layer.layerLocation!=null){
            var Pos = new window.Geo3DPoint(this.props.layer.layerLocation.POS.x , this.props.layer.layerLocation.POS.y , this.props.layer.layerLocation.POS.z);
            var V = new window.Geo3DPoint(this.props.layer.layerLocation.V.x , this.props.layer.layerLocation.V.y , this.props.layer.layerLocation.V.z);
            var Up = new window.Geo3DPoint(this.props.layer.layerLocation.UP.x , this.props.layer.layerLocation.UP.y , this.props.layer.layerLocation.UP.z);
            var Camera = new window.ov.Camera(Pos,V,Up);
            window.main.OView.gotoCamera(Camera, true);
        }
        else{
            var I3SLayer = this.props.layer.layerHandel;
            I3SLayer.goto();
        }
    }
    settingOpen(){
        this.setState({ isSettingOpen: !this.state.isSettingOpen });
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const Layer = this.props.layer;
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large find icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" onClick={(e)=>this.settingOpen()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className="large disabled setting icon"></i>
                    </div>
                </div>                
            </div>
        );
    }
}
class I3SLayer extends React.Component{
    constructor(){
        super();
        this.state = {
            isChecked:false,
            I3SLayer:{}
        };   
        this.I3SLayerChecked = this.I3SLayerChecked.bind(this);      
    }
    componentDidUpdate(){
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if(isChecked){
                window.main.OView.removeLayer(this.state.I3SLayer);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,I3SLayer:{}});
            }            
        }
    }
    I3SLayerChecked(layer){
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if(!isChecked){
            window.main.OView.addI3SLayer({
                url: layer.URL,
                urlTemplate: window.TERRAIN_SERVER.URLTemplate,
                callback: function (e,I3SLayer) {
                    if(e){
                        if(layer.LOCATION!=null){
                            var Pos = new window.Geo3DPoint(layer.LOCATION.POS.x , layer.LOCATION.POS.y , layer.LOCATION.POS.z);
                            var V = new window.Geo3DPoint(layer.LOCATION.V.x , layer.LOCATION.V.y , layer.LOCATION.V.z);
                            var Up = new window.Geo3DPoint(layer.LOCATION.UP.x , layer.LOCATION.UP.y , layer.LOCATION.UP.z);
                            var Camera = new window.ov.Camera(Pos,V,Up);
                            window.main.OView.gotoCamera(Camera, true);
                        }
                        else{
                            I3SLayer.goto();
                        }
                        window.alertify.success("已開啟圖層："+layer.TITLE);
                        layerThis.props.setOpenLayer(layer,I3SLayer);                        
                        isChecked = !isChecked;
                        layerThis.setState({isChecked:isChecked,I3SLayer:I3SLayer});
                    }
                    else if(!e){
                        window.alertify.error("連結不到圖層:："+layer.TITLE);
                    }
                }
            });                  
        }
        else{
            window.main.OView.removeLayer(this.state.I3SLayer);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            isChecked = !isChecked;    
            layerThis.setState({isChecked:isChecked,I3SLayer:{}});        
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="I3SLayer" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.I3SLayerChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {I3SLayer ,I3SOption};